<wl-content-section [id]="id()" [theme]="theme()">
  @if (fields()) {
    <wl-text-image
      [inverse]="inverse()"
      [title]="title()!"
      [content]="content()!"
      [image]="image()!"
      [primaryButton]="primaryButton()"
      [secondaryButton]="secondaryButton()"
      [microcopy]="microcopy()"
    >
      @if (showAppStoreButtons()) {
        <wl-app-store-buttons
          [appStoreButtonLink]="appStoreButton()!"
          [googlePlayButtonLink]="googlePlayButton()!"
        />
      }
    </wl-text-image>
  }
</wl-content-section>
